import { useUserContext } from "@/components/user-context";

import { LoggedOutConfluenceFree } from "./free";
import { LoggedOutConfluencePremium } from "./premium";
import { LoggedOutConfluenceStandard } from "./standard";

export const LoggedOutConfluence = () => {
    const { edition } = useUserContext();

    switch (edition) {
        case "premium":
            return <LoggedOutConfluencePremium />;
        case "standard":
            return <LoggedOutConfluenceStandard />;
        default:
            return <LoggedOutConfluenceFree />;
    }
};
